import React from 'react';
import axios from 'axios';
import moment from 'moment';
import download from 'downloadjs';
import { Button, Table, Form, Header, Loader, Popup, Icon, Checkbox } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import Filters from './Filters';
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoCurrentRequestMessage = () => <p>Nema zahtjeva za dokumente.</p>;

export default class TableRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData: [],
            studyPrograms: this.props.studyPrograms,
            sProgramId: '',
            loading: true,
            showProcessedRequests: false,
            processingId: null,
            cancellingId: null,

            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.processRequest = this.processRequest.bind(this);
        this.processed = this.processed.bind(this);

        this.getDataToRender = this.getDataToRender.bind(this);

        this.filterSPRequests = this.filterSPRequests.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (value !== '') this.filterSPRequests(value);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.tabName !== nextProps.tabName) {
            this.setState({
                results: []
            });
            this.props.loading;
        }
    }

    processed(documentRequestId) {
        axios.put(`student-documents/process/${documentRequestId}`)
            .then(res => {
                this.setState({ processingId: null });
                this.props.getRequests();
            })
            .catch(err => {
                this.setState({ processingId: null });
                console.log('Failed to process request.');
            });
    }

    processRequest(studentStudyProgramId, documentTypeId, documentRequestId, language) {
        this.setState({ processingId: documentRequestId });
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId, documentTypeId, documentRequestId, issueDate, language
        };

        axios({
            method: 'post',
            url: '/documents/requested',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    toast('Došlo je do greške! Zahtjev nije obrađen zbog nedostatka podataka.');
                    this.setState({ processingId: null });
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                this.processed(documentRequestId);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ processingId: null });
            });
    }

    cancelRequest(id) {
        this.setState({ cancellingId: id });
        axios.put(`student-documents/request-cancellation/${id}`)
            .then(res => {
                toast('Zahtjev je uspješno poništen.');
                this.setState({ cancellingId: null });
                this.props.getRequests();
            })
            .catch(err => {
                this.setState({ cancellingId: null });
                toast('Došlo je do greške! Zahtjev nije poništen.');
            });
    }


    getDataToRender() {
        if (this.state.sProgramId && this.props.requestsBySP && this.state.results.length === 0) {
            return this.state.filterData;
        }

        if (this.state.results.length !== 0) {
            return this.state.results;
        }

        return this.props.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    filterSPRequests(value) {
        axios.post(`student-documents/requests-by-study-program/${value}`, {  })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    id: el.documentRequestId,
                    documentType: this.props.documentTypes.find(e => e.id === el.documentTypeId).name,
                    certificateReason: !!el.certificateReasonId && this.props.certificateReasons.find(e => e.key === el.certificateReasonId).text,
                    status: this.props.documentStatuses.find(e => e.id === el.documentStatusId).name,
                    language: el.languageId ? this.props.languages.find(e => e.id === el.languageId).name : null,

                    date: moment(el.date).format('D. M. YYYY.'),
                    comment: el.comment,
                    processed: this.props.documentStatuses.find(e => e.id === el.documentStatusId).processed
                }
                )).filter(el => !el.processed).reverse();
                console.log('filterDAta', filterData)
                this.setState({ filterData, requestsBySP: true });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.props.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>

                {this.props.requestsBySP && <div><br />
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <label>Smjer (studijski program)</label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite smjer (studijski program)"
                                    value={this.state.sProgramId}
                                    onChange={this.handleInputChange}
                                    name="sProgramId"
                                    options={this.props.studyPrograms}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field/>
                        </Form.Group>
                    </Form></div>}


                {currentPosts.length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={this.props.requestsBySP ? 12 : 11} >
                                    <div style={{paddingLeft: '30px'}}>
                                        <SearchTableData data={this.state.sProgramId ? this.state.filterData : this.props.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'date', 'documentType']} />
                                    </div>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="3">Tip dokumenta</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Student/ica</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Index</Table.HeaderCell>
                                <Table.HeaderCell>Datum</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Napomena</Table.HeaderCell>
                                {!this.props.processed && <Table.HeaderCell></Table.HeaderCell>}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>  {currentPosts.map((el, index) =>
                            (<Table.Row key={el.id}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="3">
                                    {el.documentType}<br />{el.certificateReason}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    {el.firstName} {el.lastName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    {el.index}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.date}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    {el.comment}
                                </Table.Cell>
                                {!this.props.processed && <Table.Cell verticalAlign="middle" className="text-center" >
                                    <Popup
                                        content="Obradi"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="check"
                                                size="tiny"
                                                color="blue"
                                                loading={this.state.processingId === el.documentRequestId}
                                                disabled={this.state.processingId === el.documentRequestId || this.state.cancellingId === el.id}
                                                onClick={() => this.processRequest(el.studentStudyProgramId, el.documentTypeId, el.documentRequestId, el.languageId  === 2 ? 'en' : window.$locale === 'hr' ? 'hr' : 'bs')}
                                            />}
                                    />
                                    <Popup
                                        content="Poništi"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="delete"
                                                size="tiny"
                                                color="red"
                                                loading={this.state.cancellingId === el.id}
                                                disabled={this.state.cancellingId === el.id || this.state.processingId === el.documentRequestId}
                                                onClick={() => { this.cancelRequest(el.id); }}
                                            />}
                                    />

                                </Table.Cell>}
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : <NoCurrentRequestMessage />
                }
                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/DocumentRequests/TableRequests.js